import React from 'react'
import SEO from './SEO';
import { Helmet } from 'react-helmet-async';
import Slider from './Slider';
import OurNumber from './OurNumber';
import Client from './Client';
import Video from './Video';
import ProductNew from './ProductNew';
import AboutNew from './AboutNew';
import AboutCard from '../About/AboutCard';
import Gfooter from './Gfooter';
import Speak from './Speak';
import Whyus from '../About/Whyus';
import Navbar from './Navbar';
import ProductCard from '../product/ProductCard';
import HeadCarousel from './HeadCarousel';
import NumberNew from './NumberNew';
import ClientSpeackData from './ClientSpeackData';
import Testimonials1 from './Testimonials1';
import BranchNavbar from './location';
import CataloguePopup from './cateloguepopup';






function Home() {
    return (
        <div className="home-layout">

            {/* SEO — Homepage */}
            <SEO
                title="Architectural Solutions & Products in India | NLF Solutions"
                description="NLF Solutions provides architectural and building solutions including metal ceilings, facades, roofing, furniture and acoustic solutions across India."
                canonical="https://nlfs.in/"
                keywords="Architectural Solutions in India, Architectural products, Architectural solutions company, Facade solutions, Ceiling solutions, Interior solutions, Roofing solutions, Office furniture solutions, architectural solutions company in India, architectural products supplier in Nagpur, complete architectural solutions in India"
            />

            {/* H1 — Word file ke hisaab se */}
            <h1 className="seo-h1">Innovative Architectural Solutions for Modern Spaces</h1>
            <Navbar />
            <Video />
            <Slider />
            {/* <HeadCarousel/> */}
            <CataloguePopup />
            {/* < BranchNavbar/> */}
            <AboutNew />
            <ProductNew />

            <AboutCard />
            <Whyus />
            {/* <Testimonials1/> */}
            {/* <OurNumber/> */}
            <NumberNew />
            {/* <Speak/> */}
            {/* <ClientSpeackData/> */}
            <Client />
            <Gfooter />
        </div>
    );
}

export default Home;